import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Outlet, useLocation, useNavigate } from 'react-router-dom'
import AppLayout from './layouts/app-layout'
import HostLayout from './layouts/host-layout'
import { setNavigate } from './utils/navigate'
import withLocation from './utils/with-location'

import IndexPage from './pages/index'
import LoginPage from './pages/login'
import LogoutPage from './pages/logout'
import StartPage from './pages/start'
import FinishPage from './pages/finish'
import CaptainPage from './pages/captain'
import SettingsPage from './pages/settings'
import RulesPage from './pages/rules'
import TermsPage from './pages/terms'
import ContactPage from './pages/contact'
import GalleryPage from './pages/gallery'
import TeamGalleryPage from './pages/team-gallery'
import QrPage from './pages/qr'
import AnswersPage from './pages/answers'
import LeaderboardPage from './pages/leaderboard'
import ChecklistsPage from './pages/checklists'
import BonusChallengePage from './pages/bonus-challenge'
import MysteryMessagePage from './pages/mystery-message'
import NotificationsPage from './pages/notifications'
import NotFoundPage from './pages/404'
import QuestionsIndexPage from './pages/questions/index'
import QuestionsOverviewPage from './pages/questions/overview'
import QuestionsFinalPage from './pages/questions/final'
import EmergencyMessagePage from './pages/emergency-message/index'
import EmergencyCipherPage from './pages/emergency-message/cipher'

import HostIndexPage from './pages/host/index'
import HostLoginPage from './pages/host/login'
import HostLogoutPage from './pages/host/logout'
import HostHuntPage from './pages/host/hunt'
import HostGalleryPage from './pages/host/gallery'
import HostScriptsPage from './pages/host/scripts'
import HostPrintPage from './pages/host/print'

// Class / legacy pages that still read `props.location` (Gatsby-style)
const Checklists = withLocation(ChecklistsPage)
const QuestionsIndex = withLocation(QuestionsIndexPage)
const QuestionsFinal = withLocation(QuestionsFinalPage)
const HostHunt = withLocation(HostHuntPage)
const HostGallery = withLocation(HostGalleryPage)
const HostScripts = withLocation(HostScriptsPage)
const HostPrint = withLocation(HostPrintPage)

function NavigateBridge() {
  const navigate = useNavigate()
  useEffect(() => {
    setNavigate((to, options = {}) => {
      navigate(to, { replace: Boolean(options.replace) })
    })
  }, [navigate])
  return null
}

function AppLayoutRoute() {
  const location = useLocation()
  return (
    <AppLayout location={location}>
      <Outlet />
    </AppLayout>
  )
}

function HostLayoutRoute() {
  const location = useLocation()
  return (
    <HostLayout location={location}>
      <Outlet />
    </HostLayout>
  )
}

export default function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
      <NavigateBridge />
      <Routes>
        <Route element={<AppLayoutRoute />}>
          <Route path="/" element={<IndexPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="/start" element={<StartPage />} />
          <Route path="/finish" element={<FinishPage />} />
          <Route path="/captain" element={<CaptainPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/rules" element={<RulesPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/team-gallery" element={<TeamGalleryPage />} />
          <Route path="/qr" element={<QrPage />} />
          <Route path="/qr/" element={<QrPage />} />
          <Route path="/answers" element={<AnswersPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/checklists" element={<Checklists />} />
          <Route path="/checklists/" element={<Checklists />} />
          <Route path="/bonus-challenge" element={<BonusChallengePage />} />
          <Route path="/mystery-message" element={<MysteryMessagePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/questions" element={<QuestionsIndex />} />
          <Route path="/questions/" element={<QuestionsIndex />} />
          <Route path="/questions/overview" element={<QuestionsOverviewPage />} />
          <Route path="/questions/overview/" element={<QuestionsOverviewPage />} />
          <Route path="/questions/final" element={<QuestionsFinal />} />
          <Route path="/questions/final/" element={<QuestionsFinal />} />
          <Route path="/emergency-message" element={<EmergencyMessagePage />} />
          <Route path="/emergency-message/" element={<EmergencyMessagePage />} />
          <Route path="/emergency-message/cipher" element={<EmergencyCipherPage />} />
          <Route path="/emergency-message/cipher/" element={<EmergencyCipherPage />} />
        </Route>

        <Route path="/host" element={<HostLayoutRoute />}>
          <Route index element={<HostIndexPage />} />
          <Route path="login" element={<HostLoginPage />} />
          <Route path="logout" element={<HostLogoutPage />} />
          <Route path="hunt" element={<HostHunt />} />
          <Route path="gallery" element={<HostGallery />} />
          <Route path="scripts" element={<HostScripts />} />
          <Route path="print" element={<HostPrint />} />
        </Route>

        <Route element={<AppLayoutRoute />}>
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
